<template lang="html">
	<div class="container-scroller">
		<div class="container-fluid page-body-wrapper full-page-wrapper auth-page">
			<div class="content-wrapper d-flex align-items-center auth register-bg-1 theme-one">
				<div class="row w-100">
					<div class="col-lg-4 mx-auto">
						<h2 class="text-center mb-4">注册</h2>
						<div class="auto-form-wrapper">
							<form action="#">
								<div class="form-group">
									<div class="input-group">
										<input type="text" class="form-control" placeholder="Username">
										<div class="input-group-append">
											<span class="input-group-text">
												<i class="mdi mdi-check-circle-outline"></i>
											</span>
										</div>
									</div>
								</div>
								<div class="form-group">
									<div class="input-group">
										<input type="password" class="form-control" placeholder="Password">
										<div class="input-group-append">
											<span class="input-group-text">
												<i class="mdi mdi-check-circle-outline"></i>
											</span>
										</div>
									</div>
								</div>
								<div class="form-group">
									<div class="input-group">
										<input type="password" class="form-control" placeholder="Confirm Password">
										<div class="input-group-append">
											<span class="input-group-text">
												<i class="mdi mdi-check-circle-outline"></i>
											</span>
										</div>
									</div>
								</div>
								<!-- <div class="form-group d-flex justify-content-center">
                <div class="form-check form-check-flat mt-0">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" checked> I agree to the terms
                  </label>
                </div>
              </div> -->
								<div class="form-group">
									<button class="btn btn-primary submit-btn btn-block">注册</button>
								</div>
								<div class="text-block text-center my-3">
									<span class="text-small font-weight-semibold">已经有一个账户 ?</span>
									<a href="/login" class="text-black text-small">登录</a>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			<!-- content-wrapper ends -->
		</div>
		<!-- page-body-wrapper ends -->
	</div>

</template>

<script>
	export default {}
</script>

<style lang="css">
</style>
